<template>
    <el-table
        stripe
        v-loading="loading"
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        :header-cell-style="headCellStyle"
        :cell-style="bodyCellStyle"
        :height="tableHeight"
        @selection-change="handleSelectionChange"
    >
        <el-table-column type="selection" width="55" />
        <el-table-column :label="$t('public.table_scope')" show-overflow-tooltip prop="name">
            <template #default="{ row }">
                <i :class="row.isPlatform === 1 ? pingtaiArray[0] : pingtaiArray[1]" :title="row.isPlatform === 1 ? $t('public.customer_type_platform') : $t('public.customer_type_noplatform')"></i>
                <i :class="row.status === 1 ? activeArray[0] : activeArray[1]" :title="row.status === 1 ? $t('public.customer_status_active') : $t('public.customer_status_cancel')"></i>
                <span>{{ row.name }}</span>
            </template>
        </el-table-column>
        <el-table-column :label="$t('public.table_customer_code')" show-overflow-tooltip prop="code" />
        <el-table-column :label="$t('public.table_contact')" show-overflow-tooltip prop="contact" />
        <el-table-column :label="$t('public.table_phone')" show-overflow-tooltip prop="phone" />
        <el-table-column :label="$t('public.table_scope_type')" show-overflow-tooltip prop="orgtype">
            <template #default="{ row }">
                <span>
                    {{ orgtypeFn(row.orgtype) }}
                </span>
            </template>
        </el-table-column>
        <el-table-column :label="$t('public.table_operation')" prop="optate" width="120px">
            <template #default="{ row }">
                <el-button type="text" icon="el-icon-tickets" size="small" :title="$t('public.tbopt_detail')" @click="detailFn(row)"> </el-button>
                <el-button
                    @click="statusFn(row)"
                    :title="$t(row.status === 1 ? $t('public.customer_status_active') : $t('public.customer_status_cancel'))"
                    :icon="row.status === 1 ? 'el-icon-open' : 'el-icon-turn-off'"
                    type="text"
                    class="green"
                    size="small"
                >
                </el-button>
                <el-button @click="delFn(row)" :title="$t('public.tbopt_delete')" icon="el-icon-delete" type="text" size="small"> </el-button>
            </template>
        </el-table-column>
    </el-table>
</template>

<script>
export default {
    props: ['loading', 'tableData', 'typeArray'],
    data() {
        return {
            tableHeight: 'calc(100% - 60px)',
            pingtaiArray: ['el-icon-user-solid', 'el-icon-user'],
            activeArray: ['el-icon-open', 'el-icon-turn-off']
        };
    },
    methods: {
        handleSelectionChange(arg) {
            this.$emit('choozeTableFn', arg);
        },
        detailFn(row) {
            this.$emit('detailFn', row);
        },
        statusFn(row) {
            this.$emit('statusFn', row);
        },
        delFn(row) {
            this.$emit('delFn', row);
        }
    }
};
</script>

<style lang="scss" scoped>
.icon {
    margin-right: 5px;
}
.green {
    ::v-deep .el-icon-open {
        font-weight: bold;
    }
}

// ::v-deep .el-icon-turn-off {
//   font-weight: bold;
//   color: red;
// }
</style>
